"use client"

import { Link } from '@/components/atoms/Link'
import { buttonVariants, type ButtonProps } from '@/components/atoms/button'
import { cn } from '@/lib/utils'
import { CtaButton as CtaButtonType, Link as LinkType } from '@/content/types';
import { resolveInternalLink } from '@/lib/routing'
import { trackClick } from '@/lib/analytics'
import { Text } from '@/components/atoms/Text'

type CTAButtonProps = {
  cta: CtaButtonType | LinkType
}

export function CTAButton({ cta }: CTAButtonProps) {
  if (!cta?.label) {
    return null
  }

  const { label, linkType, href, internalLink, openInNewTab } = cta
  const isCtaButton = cta._type === 'ctaButton'

  const variantFromLinkStyle: ButtonProps['variant'] = isCtaButton
    ? cta.variant
    : cta.style === 'primaryButton'
      ? 'default'
      : cta.style === 'secondaryButton'
        ? 'secondary'
        : 'link'

  const buttonProps: ButtonProps = {
    size: isCtaButton ? (cta.size as ButtonProps['size']) : undefined,
    variant: variantFromLinkStyle as ButtonProps['variant'],
  }

  let linkUrl = '#';
  if (linkType === 'internal') {
    linkUrl = resolveInternalLink(internalLink);
  } else if (linkType === 'url' && href) {
    linkUrl = href;
  }

  return (
    <Link
      href={linkUrl}
      aria-label={label}
      target={openInNewTab ? '_blank' : '_self'}
      onClick={() => trackClick(label, linkUrl, variantFromLinkStyle || 'primary')}
      className={cn(buttonVariants({ variant: buttonProps.variant, size: buttonProps.size }), 'btn-shimmer')}
    >
      {label}
      {openInNewTab && <Text className="sr-only"> (opens in a new tab)</Text>}
    </Link>
  )
}
